// tool-fair-pay-film.jsx: losse tool /tools/fair-pay-film
// Film/AV ZZP: opdracht omschrijven → rol kiezen → zwaarteniveau & tarief zien.
// Voorgevulde state: type=film, perspectief=uitvoerder (zzp).
// Geen AI; eindstation is StepNiveau (toont het tarief, geen 'verder' knop).
import React from "react";
import { ToolShell } from "./tool-shell";
import { useToolState, useToolStep } from "./tool-storage";
import { StepRol } from "../ui/steps/step1-rol";
import { StepNiveau } from "../ui/steps/step2-niveau";

const TOOL_KEY = "fair-pay-film";
const INITIAL_STATE = {
  type: "film",
  perspectief: "uitvoerder",
  omschrijving: "",
  rollen: [],
};

const STEPS = ["Opdrachtomschrijving", "Zwaarteniveau & tarief"];

// Tool-specifieke intro-copy (wijkt af van de volledige flow).
const ROL_TITEL = "Check de Fair Pay starttarieven";
const ROL_INTRO = [
  "De sector heeft aan de Ketentafel Film/AV-productie minimale starttarieven afgesproken voor zzp'ers. Deze zijn gebaseerd op het gemiddelde van de salarisschalen uit de Cao Toneel & Dans en de Cao voor het Omroeppersoneel, en vormen de ondergrens voor eerlijke betaling.",
  "Het specialisme en de complexiteit van de opdracht kunnen de hoogte van het tarief beïnvloeden. Houd hier rekening mee bij het bepalen van het openingsbod voor de onderhandeling. Hieronder vind je de starttarieven per rol en zwaarteniveau. Het zwaarteniveau is bepaald met niveau-indicatoren op basis van taken, verantwoordelijkheden en het verwachte eindresultaat.",
  "Afhankelijk van de uiteindelijke opdracht, de benodigde ervaring en de complexiteit van een productie kan het zwaarteniveau één niveau hoger of lager liggen. Het uiteindelijke tarief kan nooit lager liggen dan het starttarief van het laagste zwaarteniveau dat bij een opdracht past.",
  "Kies hieronder de juiste rol uit de Rollengids.",
];
const NIVEAU_INTRO =
  "Het Opdracht Kompas deelt werkzaamheden in op zwaarteniveau (niveaus A t/m K). Elk zwaarteniveau heeft een eigen minimum starttarief (inclusief een zzp-opslag van 74,45%). Hieronder staat het zwaarteniveau dat bij jouw werkzaamheden hoort.";

export const ToolFairPayFilm = () => {
  const [state, setState] = useToolState(TOOL_KEY, INITIAL_STATE);
  const [step, setStep] = useToolStep(TOOL_KEY, STEPS.length - 1);

  const next = () => setStep(s => Math.min(STEPS.length - 1, s + 1));
  const back = () => setStep(s => Math.max(0, s - 1));

  return (
    <ToolShell steps={STEPS} currentStep={step} onJumpTo={setStep}>
      {step === 0 && (
        <StepRol
          state={state}
          setState={setState}
          next={next}
          disableAI
          titleOverride={ROL_TITEL}
          subOverride={ROL_INTRO}
        />
      )}
      {step === 1 && (
        <StepNiveau
          state={state}
          setState={setState}
          back={back}
          hideNext
          subOverride={NIVEAU_INTRO}
        />
      )}
    </ToolShell>
  );
};
